<footer class="app-footer py-3 mt-5 border-top bg-light text-dark">
  <div class="container-fluid">
    <div class="row align-items-center">
      <!-- Left -->
      <div class="col-12 text-center">
        <p class="mb-0 small">
          © <strong>2025</strong> 
          <span class="text-primary">Nextport IT Solutions</span> |
          📞 +94 777 243 024 |
          ✉️ <a href="mailto:chamath@nextport.lk" class="text-decoration-none text-primary">chamath@nextport.lk</a>
        </p>
      </div>
    </div>
  </div>
</footer>

